import { CommonModule } from '@angular/common';
import { Component, computed, ElementRef, input, output, viewChild } from '@angular/core';
import { DebounceClickDirective } from '../../directives/debounce-click.directive';
import { ButtonSize, ButtonVariant } from '../../types/button.types';

@Component({
  selector: 'ds-button',
  imports: [CommonModule, DebounceClickDirective],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  public size = input<ButtonSize>('standard');
  public variant = input<ButtonVariant>('primary');
  public type = input<'button' | 'submit' | 'reset'>('button');
  public stretched = input(false);
  public disabled = input<boolean>(false);
  public debounceTime = input<number>(0);
  public formId = input<string>();
  public ariaLabel = input<string | undefined>('');
  public ariaExpanded = input<boolean | undefined>(undefined);
  public ariaControls = input<string | undefined>(undefined);

  public clickEvent = output();
  readonly element = viewChild<ElementRef>('button');

  protected cssClasses = computed(() => [
    `btn--${this.size()}`,
    `btn--${this.variant()}`,
    this.disabled() ? 'btn--disabled' : '',
    this.stretched() ? 'btn--stretched' : '',
  ]);

  protected onClickEvent() {
    this.clickEvent.emit();
  }

  public focus() {
    this.element()?.nativeElement.focus();
  }
}
